import styled from 'styled-components';
import { layout, remCalc, media } from '@prisjakt/ui-base';

const InfoLink = styled.div`
  align-self: flex-start;
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
  text-align: center;
  line-height: 1.5;
  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
  a,
  a:hover {
    color: inherit;
  }
`;

const OldReviewsHeader = styled.div`
  padding-top: ${layout.margins.wrapper.desktop.rem};
  border-top: 1px solid ${p => p.theme.lines.primary};
  margin-top: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
    padding-top: ${layout.margins.wrapper.mobile.rem};
    margin-top: ${layout.margins.component.mobile.rem};
  `}
`;

const SortedBy = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
  font-size: ${remCalc(12)};
`;

const EditButton = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

const Summary = styled.div.attrs({ 'data-test': 'ReviewsSummary' })`
  display: flex;
  flex-direction: row;
`;

const Prompt = styled.div`
  margin: ${props => (props.highlighted ? '15px auto' : '0 0 0 auto')};
  text-align: center;
`;

export { InfoLink, OldReviewsHeader, SortedBy, EditButton, Summary, Prompt };
